export type ActiveState = 'running' | 'attention' | null;

export function runInFlight(
  hasRunId: boolean,
  status: string | null,
  pollFailed: boolean,
): boolean {
  if (!hasRunId || pollFailed) return false;
  return status === null || status === 'running';
}

export function stepperState(running: boolean, status: string | null): ActiveState {
  if (running) return 'running';
  return status === 'failed' ? 'attention' : null;
}
